import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { RequestSurveyReportRPC } from "./requestSurveyReportRPC";

export class RequestSurveyReportRPCClientImpl extends RequestSurveyReportRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: RequestSurveyReportRPC.Request): Promise<LeoRPCResult<RequestSurveyReportRPC.Response, RequestSurveyReportRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "project/RequestSurveyReport",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      RequestSurveyReportRPC.ResponseDTO,
      RequestSurveyReportRPC.Errors.ErrorsDTO,
      RequestSurveyReportRPC.Response,
      RequestSurveyReportRPC.Errors.Errors
    >(
      response,
      "project/RequestSurveyReport",
      RequestSurveyReportRPC.Response.fromDTO,
      RequestSurveyReportRPC.Errors.fromDTO
    );
  }
}
